import iro from "@jaames/iro";

export default class PrimariesV2 {
	constructor() {
		this.blockName = "PrimariesV2";
		this.opacity = {
			minValue: 0,
			maxValue: 100,
		};
	}

	addBlock(blockNum = lutify.blocks.length) {
		UI.createAdjustmentBlockTemplate(this.blockName, blockNum);
		const element = UI.getAdjustmentBlock(blockNum);

		$(element)
			.find(".control-selector__items-container > span")
			.on("click", (e, animate) => this.controlSelection(e.currentTarget, animate));
		$(element)
			.find(".btn-reset-block")
			.off("click")
			.on("click", _ => this.resetBlock($(element)));
		$(element)
			.find(".colorwheel-container")
			.on("dblclick", e => this.resetColorWheel($(e.currentTarget)));
		$(element)
			.find('.block-controls-container[data-control="sliders"] .slider-control')
			.on("dblclick", e => this.resetVerticalSlider($(e.currentTarget)));

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);
		$(element)
			.find('.control-selector__items-container > span[data-control="wheels"]')
			.trigger("click", [false]);

		$(element)
			.find('.block-controls-container[data-control="wheels"] .slider-control')
			.on("input", e => this.sliderHandler($(e.currentTarget)));
		$(element)
			.find('.block-controls-container[data-control="wheels"] .slider-input-control')
			.on("change", e => this.sliderInputHandler($(e.currentTarget)));

		$(element)
			.find('.block-controls-container[data-control="sliders"] .slider-control')
			.on("input", e => this.verticalSliderHandler($(e.currentTarget)));
		$(element)
			.find('.block-controls-container[data-control="sliders"] .slider-input-control')
			.on("change", e => this.verticalSliderInputHandler($(e.currentTarget)));

		$(element).find(".opacity_slider").on("input", () => this.opacitySliderHandler($(element)));
		$(element).find(".opacity-input").on("change", () => this.opacityInputHandler($(element)));

		$(element)
			.find(".control-selector__label-container")
			.on("click", e => {
				e.stopPropagation();
				this.toggleControlSelector($(e.currentTarget));
			});

		UI.initKnob(element);

		blocks.add({
			name: this.blockName,
			version: '2',
			passes: this.addPasses(),
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			opacity: 100,
			values: {
				wheels: {
					lift: { Y: 0.000, R: 0.000, G: 0.000, B: 0.000 },
					gamma: { Y: 0.000, R: 1.000, G: 1.000, B: 1.000 },
					gain: { Y: 0.000, R: 1.000, G: 1.000, B: 1.000 },
					offset: { Y: 0.000, R: 0.000, G: 0.000, B: 0.000 },
				},
				sliders: {
					lift: { Y: 0.000, R: 0.000, G: 0.000, B: 0.000 },
					gamma: { Y: 0.000, R: 1.000, G: 1.000, B: 1.000 },
					gain: { Y: 0.000, R: 1.000, G: 1.000, B: 1.000 },
					offset: { Y: 0.000, R: 0.000, G: 0.000, B: 0.000 },
				},
			},
			colorWheels: this.colorWheelsInit($(element)),
		});

		this.slidersInit($(element));

		// Average blending mode
		$(element).find(`.blending-mode__items-container > span[data-id="22"]`).trigger("click");
	}

	addPasses() {
		let shaderPassWheels = gpu.createLiftGammaGainPass();
		let shaderPassBars = gpu.createLiftGammaGainPass();
		gpu.addPassToComposer(shaderPassWheels, "toMiddle");
		gpu.addPassToComposer(shaderPassBars, "toMiddle");
		return [shaderPassWheels, shaderPassBars];
	}

	colorWheelsInit($element) {
		let colorWheels = [];
		let colorWheelContainers = $element.find(".colorwheel-container");

		for (let i = 0; i < 4; i++) {
			let colorWheel = new iro.ColorPicker(colorWheelContainers[i], config.colorWheelOptions);
			colorWheel.on("color:change", colors => this.colorChangeHandler(colorWheelContainers[i], colors));
			colorWheels.push(colorWheel);
		}

		return colorWheels;
	}

	slidersInit($element) {
		$element.find('.block-controls-container[data-control="sliders"] .slider-control').slider({
			orientation: "vertical",
			width: 1,
			range: "min",
			min: -1,
			max: 1,
			step: 0.001,
			value: 0,
			change: (event, ui) => this.verticalSliderHandler(event, ui),
			slide: (event, ui) => this.verticalSliderHandler(event, ui),
		});

		$element.find('.block-controls-container[data-control="sliders"] .slider-control').each((index, sliderControl) => {
			let html = document.createElement("div");
			html.setAttribute("class", "slider-control-fill");
			$(sliderControl).append(html);
		});
	}

	toggleControlSelector($el) {
		let itemsContainer = $el.siblings(".control-selector__items-container");
		if (itemsContainer.is(":visible")) itemsContainer.hide();
		else itemsContainer.show();
	}

	controlSelection(selectedControl, animate = true) {
		let $blockOptions = $(selectedControl).closest(".block_options");
		$blockOptions.find(".control-selector__items-container").hide();
		$blockOptions.find(".selected-control-name").html($(selectedControl).html());
		if (animate) {
			$blockOptions.find(".block-controls-container").fadeOut(2);
			$blockOptions.find(`.block-controls-container[data-control="${selectedControl.dataset.control}"]`).fadeIn();
		} else {
			$blockOptions.find(`.block-controls-container[data-control="${selectedControl.dataset.control}"]`).show();
		}
	}

	colorChangeHandler(colorWheelElement, colors) {
		blocks.checkSwitchHandler($(colorWheelElement).closest(".adjustment-block"));
		lutify.setActiveBlock(
			parseInt(
				$(colorWheelElement)
					.closest(".adjustment-block")
					.attr("orignum")
			)
		);

		let controlName = $(colorWheelElement)
			.data("curve")
			.split("-")[0];
		// let controlCurve = $(colorWheelElement).data('curve').split('-')[1];

		lutify.getActiveBlock().passes[0].enabled = true;

		let newColors = {};

		if (['lift', 'offset'].includes(controlName)) {
			newColors.r = Number((colors.rgb.r / 255).toFixed(3)) - 1;
			newColors.g = Number((colors.rgb.g / 255).toFixed(3)) - 1;
			newColors.b = Number((colors.rgb.b / 255).toFixed(3)) - 1;
		} else if (['gamma', 'gain'].includes(controlName)) {
			newColors.r = Number((colors.rgb.r / 255).toFixed(3));
			newColors.g = Number((colors.rgb.g / 255).toFixed(3));
			newColors.b = Number((colors.rgb.b / 255).toFixed(3));
		}

		lutify.getActiveBlock().values.wheels[controlName].R = newColors.r;
		lutify.getActiveBlock().values.wheels[controlName].G = newColors.g;
		lutify.getActiveBlock().values.wheels[controlName].B = newColors.b;

		lutify.getActiveBlock().passes[0].uniforms[controlName].value.x = newColors.r;
		lutify.getActiveBlock().passes[0].uniforms[controlName].value.y = newColors.g;
		lutify.getActiveBlock().passes[0].uniforms[controlName].value.z = newColors.b;

		gpu.render();

		if (!UI.mouse.knobDrag) {
			$(colorWheelElement)
				.closest(".control-container")
				.find(`.slider-input-control[data-curve="${controlName}-R"]`)
				.val(newColors.r.toFixed(3));
			$(colorWheelElement)
				.closest(".control-container")
				.find(`.slider-input-control[data-curve="${controlName}-G"]`)
				.val(newColors.g.toFixed(3));
			$(colorWheelElement)
				.closest(".control-container")
				.find(`.slider-input-control[data-curve="${controlName}-B"]`)
				.val(newColors.b.toFixed(3));
		}
	}

	sliderHandler($sliderElement) {
		blocks.checkSwitchHandler($sliderElement.closest(".adjustment-block"));

		let controlName = $sliderElement.data("curve").split("-")[0];
		// let controlCurve = $sliderElement.data("curve").split("-")[1];

		lutify.getActiveBlock().passes[0].enabled = true;
		lutify.getActiveBlock().values.wheels[controlName].Y = Number($sliderElement.val());

		lutify.getActiveBlock().passes[0].uniforms[controlName].value.w = Number($sliderElement.val());
		gpu.render();

		$sliderElement
			.closest(".control-container")
			.find(`.slider-input-control[data-curve="${controlName}-Y"]`)
			.val(parseFloat($sliderElement.val()).toFixed(3));
	}

	sliderInputHandler($sliderInputElement) {
		blocks.checkSwitchHandler($sliderInputElement.closest(".adjustment-block"));

		let controlName = $sliderInputElement.data("curve").split("-")[0];
		let controlCurve = $sliderInputElement.data("curve").split("-")[1];

		lutify.getActiveBlock().passes[0].enabled = true;

		let sliderInputValue = $sliderInputElement.val();

		if (sliderInputValue > parseFloat($sliderInputElement.attr("max"))) sliderInputValue = $sliderInputElement.attr("max");
		if (sliderInputValue < parseFloat($sliderInputElement.attr("min"))) sliderInputValue = $sliderInputElement.attr("min");

		const $inputR = $sliderInputElement.closest(".control-container").find(`.slider-input-control[data-curve=${controlName}-R]`);
		const $inputG = $sliderInputElement.closest(".control-container").find(`.slider-input-control[data-curve=${controlName}-G]`);
		const $inputB = $sliderInputElement.closest(".control-container").find(`.slider-input-control[data-curve=${controlName}-B]`);

		let inputR = parseFloat($inputR.val());
		let inputG = parseFloat($inputG.val());
		let inputB = parseFloat($inputB.val());

		// don't allow all three inputs to have min value
		if (controlCurve !== 'Y' && [inputR, inputG, inputB].filter(e => e !== parseFloat($sliderInputElement.attr("data-default-value"))).length == 3) {
			sliderInputValue = $sliderInputElement.attr("data-default-value");
		}

		$sliderInputElement.val(sliderInputValue);

		inputR = parseFloat($inputR.val());
		inputG = parseFloat($inputG.val());
		inputB = parseFloat($inputB.val());

		lutify.getActiveBlock().values.wheels[controlName][controlCurve] = Number(sliderInputValue);

		// slider R,G,B
		if (controlCurve == "R" || controlCurve == "G" || controlCurve == "B") {
			let colors = {};
			if (['lift', 'offset'].includes(controlName)) {
				colors.r = Number(((inputR + 1) * 255).toFixed(3));
				colors.g = Number(((inputG + 1) * 255).toFixed(3));
				colors.b = Number(((inputB + 1) * 255).toFixed(3));
			} else if (['gamma', 'gain'].includes(controlName)) {
				colors.r = Number((inputR * 255).toFixed(3));
				colors.g = Number((inputG * 255).toFixed(3));
				colors.b = Number((inputB * 255).toFixed(3));
			}

			if (controlName == "lift") lutify.getActiveBlock().colorWheels[0].color.rgb = colors;
			else if (controlName == "gamma") lutify.getActiveBlock().colorWheels[1].color.rgb = colors;
			else if (controlName == "gain") lutify.getActiveBlock().colorWheels[2].color.rgb = colors;
			else if (controlName == "offset") lutify.getActiveBlock().colorWheels[3].color.rgb = colors;
		}

		// slider Y
		else {
			let $sliderControlElement = $sliderInputElement.closest(".control-container").find(`.slider-control[data-curve="${controlName}-Y"]`);
			$sliderControlElement.val($sliderInputElement.val());
			$sliderControlElement.trigger("input");
		}
	}

	verticalSliderHandler(event, ui) {
		let $sliderControlElement = $(event.target);
		let controlName = $sliderControlElement.data("curve").split("-")[0];
		let controlCurve = $sliderControlElement.data("curve").split("-")[1];

		let inputValue = ui.value;
		if (controlCurve !== 'Y' && ['gamma', 'gain'].includes(controlName)) {
			inputValue += 1;
		}

		lutify.getActiveBlock().values.sliders[controlName][controlCurve] = Number(inputValue);
		lutify.getActiveBlock().passes[1].enabled = true;

		if (['lift', 'offset'].includes(controlName)) {
			lutify.getActiveBlock().passes[1].uniforms[controlName].value.x = lutify.getActiveBlock().values.sliders[controlName]["R"];
			lutify.getActiveBlock().passes[1].uniforms[controlName].value.y = lutify.getActiveBlock().values.sliders[controlName]["G"];
			lutify.getActiveBlock().passes[1].uniforms[controlName].value.z = lutify.getActiveBlock().values.sliders[controlName]["B"];
			lutify.getActiveBlock().passes[1].uniforms[controlName].value.w = lutify.getActiveBlock().values.sliders[controlName]["Y"];
		} else if (['gamma', 'gain'].includes(controlName)) {
			lutify.getActiveBlock().passes[1].uniforms[controlName].value.x = lutify.getActiveBlock().values.sliders[controlName]["R"];
			lutify.getActiveBlock().passes[1].uniforms[controlName].value.y = lutify.getActiveBlock().values.sliders[controlName]["G"];
			lutify.getActiveBlock().passes[1].uniforms[controlName].value.z = lutify.getActiveBlock().values.sliders[controlName]["B"];
			lutify.getActiveBlock().passes[1].uniforms[controlName].value.w = lutify.getActiveBlock().values.sliders[controlName]["Y"];
		}

		gpu.render();

		let $sliderInputElement = $sliderControlElement
			.closest(".control-container")
			.find(`.slider-input-control[data-curve="${controlName}-${controlCurve}"]`);

		$sliderInputElement.val(parseFloat(inputValue).toFixed(3));

		this.updateSliderUI($(event.target).closest(".slider-control"), ui.value);
		blocks.checkSwitchHandler($(event.target).closest(".adjustment-block"));
	}

	verticalSliderInputHandler($sliderInputElement) {
		let controlName = $sliderInputElement.data("curve").split("-")[0];
		let controlCurve = $sliderInputElement.data("curve").split("-")[1];

		let inputValue = Number($sliderInputElement.val());
		lutify.getActiveBlock().values.sliders[controlName][controlCurve] = inputValue;

		if (['R', 'G', 'B'].includes(controlCurve)) {
			if (['gamma', 'gain'].includes(controlName)) {
				inputValue -= 1;
			}
		}

		let $sliderControlElement = $sliderInputElement
			.closest(".control-container")
			.find(`.slider-control[data-curve="${controlName}-${controlCurve}"]`);
		$sliderControlElement.slider("value", inputValue);

		blocks.checkSwitchHandler($sliderInputElement.closest(".adjustment-block"));
	}

	resetBlock($element) {
		let $sliderInputControls = $element.find(".slider-input-control");
		$sliderInputControls.each(function() {
			$(this).val($(this).data("default-value"));
		});
		$sliderInputControls.trigger("change");
		lutify.getActiveBlock().passes.forEach(pass => (pass.enabled = false));
	}

	resetColorWheel($colorWheelContainer) {
		// let controlName = $colorWheelContainer.data('curve').split('-')[0];
		// let controlCurve = $colorWheelContainer.data("curve").split("-")[1];
		let $sliderInputControls = $colorWheelContainer.closest(".control-container").find(".slider-input-control");

		$sliderInputControls.each(function(i) {
			if (i !== 0) {
				$(this).val($(this).data("default-value"));
				$(this).trigger("change");
			}
		});
	}

	resetVerticalSlider($slider) {
		let defaultValue = $slider.data("default-value");
		let controlName = $slider.data("curve").split("-")[0];
		let controlCurve = $slider.data("curve").split("-")[1];

		if (['R', 'G', 'B'].includes(controlCurve)) {
			if (['gamma', 'gain'].includes(controlName)) {
				defaultValue -= 1;
			}
		}

		$slider.slider("value", Number(defaultValue));
	}

	updateSliderUI($slider, sliderValue) {
		let $sliderControlElementHeight = $slider.height();
		let sliderControlFillHeight = Math.abs(($sliderControlElementHeight * sliderValue) / 2);
		let $sliderControlFillElement = $slider.find(".slider-control-fill");
		$sliderControlFillElement.css("height", `${sliderControlFillHeight}px`);

		if (sliderValue > 0) {
			$sliderControlFillElement.css({
				bottom: "50%",
				top: "initial",
			});
		} else if (sliderValue < 0) {
			$sliderControlFillElement.css({
				top: "50%",
				bottom: "initial",
			});
		}
	}

	opacitySliderHandler($element) {
		let opacityValue = $element.find(".opacity_slider").val();
		let calcOpacityValue = opacityValue * 0.01;

		$element.find(".opacity-input").val(opacityValue);

		lutify.getActiveBlock().opacity = opacityValue;
		lutify.getActiveBlock().passes.forEach(pass => {
			pass.uniforms.opacity.value = calcOpacityValue;
		})

		gpu.render();
	}

	opacityInputHandler($element) {
		let opacityValue = $element.find(".opacity-input").val();
		let opacitySlider = $element.find(".opacity_slider");

		if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
		if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

		opacitySlider.val(opacityValue);
		opacitySlider.trigger("input");
	}

	applyChanges($block, values, blockData) {
		Object.keys(values).forEach(control => {
			Object.keys(values[control]).forEach(curve => {
				let R = values[control][curve].R;
				let G = values[control][curve].G;
				let B = values[control][curve].B;
				let Y = values[control][curve].Y;

				$block
					.find(`.block-controls-container[data-control="${control}"] .slider-input-control[data-curve="${curve}-Y"]`)
					.val(Y.toFixed(3));
				$block
					.find(`.block-controls-container[data-control="${control}"] .slider-input-control[data-curve="${curve}-R"]`)
					.val(R.toFixed(3));
				$block
					.find(`.block-controls-container[data-control="${control}"] .slider-input-control[data-curve="${curve}-G"]`)
					.val(G.toFixed(3));
				$block
					.find(`.block-controls-container[data-control="${control}"] .slider-input-control[data-curve="${curve}-B"]`)
					.val(B.toFixed(3));

			});
		});

		$block.find('.block-controls-container[data-control="wheels"] .slider-input-control').trigger("change");
		$block.find('.block-controls-container[data-control="sliders"] .slider-input-control').trigger("change");

		if ('opacity' in blockData) {
			$block.find(".opacity-input").val(parseInt(blockData.opacity));
			$block.find(".opacity-input").trigger("change");
		}
	}
}
